window.openMobileSidebar = function () {
  const sidebar = document.getElementById('mobile-sidebar');
  const overlay = document.getElementById('sidebar-overlay');

  sidebar.classList.remove('tw-translate-x-full');
  overlay.classList.remove('tw-hidden');
  document.body.style.overflow = 'hidden';
};

window.closeMobileSidebar = function () {
  const sidebar = document.getElementById('mobile-sidebar');
  const overlay = document.getElementById('sidebar-overlay');

  sidebar.classList.add('tw-translate-x-full');
  overlay.classList.add('tw-hidden');
  document.body.style.overflow = '';
};
